import { http } from "@/core/ApiConfig";
import { Edital } from "@/core/models/geral";
import { Service } from "../shared/Service";

export class EditalService extends Service {

  constructor() {
    super('edital');
  }

  Publicar(id: number) {
    return http.post(`${this.GetNomeControle()}/${id}/publicar`);
  }

  EnviarRegulamento(id: number, nome: string, arquivo: any) {
    let bodyFormData = new FormData();
    bodyFormData.append('arquivo', new Blob([arquivo], { type: 'application/pdf' }));

    return http.post(`${this.GetNomeControle()}/${id}/regulamento`, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: {
        nome
      }
    })
  }

  DownloadRegulamento(id: number, nome: string) {
    return http.get(`${this.GetNomeControle()}/${id}/regulamento`, {
      // responseType: 'blob',
      params: {
        nome
      }
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      document.body.appendChild(link);
      link.click();
    })
  }

  VisualizarRegulamento(id: number, nome: string) {
    return http.get(`${this.GetNomeControle()}/${id}/regulamento/visualizar`, {
      params: {
        nome
      }
    });
  }

  DeletarRegulamento(id: number, nome: string) {
    return http.delete(`${this.GetNomeControle()}/${id}/regulamento`, {
      params: {
        nome
      }
    })
  }

  GetByOngId(ongId: number) {
    return http.get(`${this.GetNomeControle()}/Ong/${ongId}`);
  }

  DentroPrazo() {
    return http.get(`${this.GetNomeControle()}/DentroPrazo`);
  }

  ObterLogo(id: number) {
    return http.get(`${this.GetNomeControle()}/${id}/logo`);
  }

  ObterBanner(id: number) {
    return http.get(`${this.GetNomeControle()}/${id}/banner`);
  }

  SubstituirLogo(id: number, conteudoBase64: string) {
    return http.put(`${this.GetNomeControle()}/${id}/logo`, { conteudoBase64 });
  }

  RemoverLogo(id: number) {
    return http.delete(`${this.GetNomeControle()}/${id}/logo`);
  }

  SubstituirBanner(id: number, conteudoBase64: string) {
    return http.put(`${this.GetNomeControle()}/${id}/banner`, { conteudoBase64 });
  }

  RemoverBanner(id: number) {
    return http.delete(`${this.GetNomeControle()}/${id}/banner`);
  }

  async ObterEstrutura(id: number): Promise<Edital> {
    const [
      editalRes,
      areaAtuacoesRes,
      bairroComunidadesRes,
      documentosRes,
      incentivosRes,
      publicoAlvosRes,
      empreendedoresRes,
      formulariosRes
    ] = await Promise.all([
      this.ObterPorId(id),
      this.ObterPorId(id, "AreaAtuacoes"),
      this.ObterPorId(id, "BairroComunidades.BairroComunidade.Estado, BairroComunidades.BairroComunidade.Municipio"),
      this.ObterPorId(id, "Documentos.TipoDocumento"),
      this.ObterPorId(id, "Incentivos.Incenvito"),
      this.ObterPorId(id, "PublicoAlvos"),
      this.ObterPorId(id, "Empreendedores"),
      this.ObterPorId(id, "Formularios.Campos.Valores")
    ]);

    const edital = new Edital(editalRes.data);
    edital.areaAtuacoes = areaAtuacoesRes.data.areaAtuacoes;
    edital.bairroComunidades = bairroComunidadesRes.data.bairroComunidades;
    edital.documentos = documentosRes.data.documentos;
    edital.incentivos = incentivosRes.data.incentivos;
    edital.publicoAlvos = publicoAlvosRes.data.publicoAlvos;
    edital.empreendedores = empreendedoresRes.data.empreendedores;
    edital.formularios = formulariosRes.data.formularios;

    return edital;
  }

  async ObterParaCadastro(id: number): Promise<Edital> {
    const [edital, logo, banner] = await Promise.all([
      this.ObterEstrutura(id),
      this.ObterLogoComResultado(id),
      this.ObterBannerComResultado(id)
    ]);

    edital.logo = logo.conteudo;
    edital.logoErro = logo.erro;
    edital.banner = banner.conteudo;
    edital.bannerErro = banner.erro;

    return edital;
  }

  async ObterLogoComResultado(id: number): Promise<{ conteudo: any, erro: any }> {
    try {
      const response = await this.ObterLogo(id);
      return { conteudo: response.data ?? null, erro: null };
    }
    catch (erro) {
      return { conteudo: null, erro };
    }
  }

  async ObterBannerComResultado(id: number): Promise<{ conteudo: any, erro: any }> {
    try {
      const response = await this.ObterBanner(id);
      return { conteudo: response.data ?? null, erro: null };
    }
    catch (erro) {
      return { conteudo: null, erro };
    }
  }

  ObterCompleto(id: number): Promise<Edital> {
    return this.ObterParaCadastro(id);
  }

  HasProjeto(ongId: number) {
    return http.get(`${this.GetNomeControle()}/HasProjeto`, {
      params: {
        ongId
      }
    });
  }

  TipoDocumento(id: number) {
    return http.get(`${this.GetNomeControle()}/${id}/TipoDocumento`);
  }

  TipoEdital(id: number) {
    return http.get(`${this.GetNomeControle()}/${id}/Tipo`);
  }

}
